<template>
  <div>
    <b-carousel
      :arrow="modalConfig.arrow"
      :arrow-both="modalConfig.arrowBoth"
      :arrow-hover="modalConfig.arrowHover"
      :icon-pack="modalConfig.iconPack"
      :icon-prev="modalConfig.iconPrev"
      :icon-next="modalConfig.iconNext"
      :icon-size="modalConfig.iconSize"
      :has-drag="true"
      :autoplay="false"
      @change="onSlideChange"
      ref="popupCarousel"
    >
      <b-carousel-item
        v-for="(slide, i) in slidesContent.slides"
        :key="'carousel-item-' + i"
      >
        <section class="hero is-small">
          <div class="hero-body has-text-centered">
            <div class="image slide-img" v-if="isImageSlide(slide.type)">
              <img :src="getSlideSrc(popup, i)" alt="" />
            </div>
            <div
              class="image slide-img"
              v-if="isVideoSlide(slide.type)"
              @mousedown="killDrag"
              @mouseup="killDrag"
              @touchstart.stop="killDrag"
              @touchend.stop="killDrag"
            >
              <plyrue
                type="video"
                :src="getSlideSrc(popup, i)"
                :poster="getSlidePoster(popup, i)"
                :options="videoOptions"
                :ref="'video_' + i"
              ></plyrue>
              <!--                <video-->
              <!--                  :src="getSlideSrc(popup, i)"-->
              <!--                  :poster="getSlidePoster(popup, i)"-->
              <!--                ></video>-->
            </div>
            <div class="linklist slide-img" v-if="isLinkListSlide(slide.type)">
              <div class="container">
                <div class="box">
                  <div class="card-header has-background-light is-block">
                    <h1
                      class="title is-4 is-block py-3 has-text-centered is-uppercase"
                    >
                      {{ slide.popupTitle }}
                    </h1>
                  </div>
                  <div class="card-content py-16 px-10">
                    <ul
                      class="link-list px-1 py-2"
                      @mousedown="killDrag"
                      @mouseup="killDrag"
                      @touchstart.stop="killDrag"
                      @touchend.stop="killDrag"
                    >
                      <li
                        v-for="(item, idx) in slide.links"
                        :key="'link_' + idx"
                        class="link-item"
                      >
                        <a
                          class="is-block is-hoverable"
                          :href="item.url"
                          target="_blank"
                        >
                          <span class="is-block title is-4"
                            ><b-icon
                              icon="link"
                              class="mr-3"
                              size="is-small"
                            ></b-icon>
                            {{ item.title }}</span
                          >
                          <span class="is-block subtitle is-5 has-text-link">{{
                            item.subtitle
                          }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      modalConfig: {
        arrow: true,
        arrowBoth: false,
        arrowHover: false,
        iconPack: "mdi",
        iconPrev: "arrow-left",
        iconNext: "arrow-right",
        iconSize: "",
      },
      carouselModel: {
        activeItem: 0,
      },
      videoOptions: {
        tooltips: false,
        controls: ["play-large", "play", "progress", "current-time", "volume"],
        ratio: "1280:720",
      },
    };
  },
  computed: {
    ...mapState(["popup", "popupContent", "content"]),
    activeSlide() {
      return 1;
    },
    slidesContent() {
      if (this.popupContent < 0) return null;
      console.log("debug", this.content[this.popupContent]);
      return this.content[this.popupContent];
    },
  },
  methods: {
    isVideoSlide(slideType) {
      return slideType == "video";
    },
    isImageSlide(slideType) {
      return slideType == "image";
    },
    isLinkListSlide(slideType) {
      console.log("is linklist", slideType == "linkList");
      return slideType == "linkList";
    },
    getSlideSrc(popup, img) {
      // console.log(
      //   popup,
      //   img,
      //   this.slidesContent,
      //   this.slidesContent.slides[img]
      // );

      var ext = this.slidesContent.slides[img].type == "video" ? "mp4" : "jpg";
      return `static/img/${this.slidesContent.path}${this.slidesContent.slides[img].path}`;
    },
    getSlidePoster(popup, img) {
      if ("undefined" != typeof this.slidesContent.slides[img].cover) {
        console.log("<>", this.slidesContent.slides[img]);
        return `static/img/${this.slidesContent.path}${this.slidesContent.slides[img].cover}`;
      }
      return `static/img/video-cover.jpg`;
    },
    onSlideChange(value, value2) {
      console.log("slide change", value, this.$refs, value2);

      try {
        Object.keys(this.$refs).forEach((el) => {
          if (el.indexOf("video") == 0) {
            if (this.$refs[el][0].player.playing) {
              this.$refs[el][0].player.stop();
            }
          }
        });
      } catch (err) {}
    },
    killDrag(e) {
      e.stopPropagation(e);
    },
  },
};
</script>

<style scoped>
.slide-img .container {
  max-width: 1280px;
}
.link-item {
  border-bottom: 1px solid #ccc;
  padding: 20px 0;
}

.link-item a .title {
  color: #0c5eff;
}
.link-item a .subtitle {
  color: #aaa;
}
.link-item a:hover .title {
  color: #002f8b;
}
.link-item a:hover .subtitle {
  color: #666;
}
.box {
  max-height: 90vh;
  min-height: 40vh;
}
.link-list {
  max-height: 50vh;
  overflow: auto;
  text-align: left;
}

.slide-img {
  --plyr-color-main: #0040be;
}

.slide-img /deep/ .plyr__control--overlaid {
  --plyr-control-icon-size: 40px;
  --plyr-control-spacing: 25px;
}
@media screen and (max-width: 1324px) {
  .plyrue {
    max-width: 90%;
    margin: 0 auto;
  }
}
</style>
